module.exports = __webpack_public_path__ + "img/header.fa31ccd3.jpg";